import React from "react";
import PropTypes from "prop-types";
import FieldOption from "../field_options/FieldOption";
import FieldSurveyNext from "../fields/FieldSurveyNext";
import { buildSurveyFieldStylesheet } from "../elements/ElementSurveyStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const FieldSurvey = (props) => {
  let element = props.element;
  let field = props.field;
  let important = props.builder !== true ? " !important" : "";
  const classes = style.classes(element);
  const stylesheet = buildSurveyFieldStylesheet(
    props.builder,
    props.device,
    props.cta,
    element,
    props.variant,
    field
  );

  let field_options = Object.values(field.field_options).filter(
    (field_option) =>
      field_option.field_id == field.id && field_option.toBeDeleted !== true
  );

  let sorted_field_options = Object.values(field_options).sort(function (a, b) {
    return a.position - b.position;
  });

  // prettier-ignore
  const isVisualChoiceComponent = () => {
    // if a legacy survey uses the new range slider to update image widht it would lead to the image not showing bc the
    // old classes only supported those fixed values. So if the image is different automatically renders the news component.
    let old_component_supported_widths = ["120", "200", "300", "400", "500", "600", "700",];
    if (element.options["options-image-width"] && old_component_supported_widths.includes(element.options["options-image-width"]) == false) {
      return true;
    }

    let hasImageVisualType = field_options.filter((f) => f.visual_type === "image" && f.image !== "none").length > 0
    let hasLetterVisualType = field_options.filter((f) => f.visual_type === "letter" && f.letter).length > 0
    let hasIconVisualType = field_options.filter((f) => f.visual_type === "icon" && f.icon).length > 0
    let hasEmojiVisualType = field_options.filter((f) => f.visual_type === "emoji" && f.emoji).length > 0
    let hasColorVisualType = field_options.filter((f) => f.visual_type === "color").length > 0
    let hasVisualTypeDefined = element.options["visual-type-placement"] != undefined || props.variant.options["visual-type-placement"] != undefined;

    return (
      hasVisualTypeDefined ||
      hasEmojiVisualType ||
      hasIconVisualType ||
      hasLetterVisualType ||
      hasColorVisualType ||
      hasImageVisualType
    );
  };

  return (
    <React.Fragment>
      <div
        className={classes}
        id={"field_" + field.id}
        data-id={field.id}
        data-field-id={field.id}
        data-field={field.slug}
        data-multi-select={field.multi_select}
        data-confirmation-button={field.options["confirmation_button"]}
        data-pos={field.position ? field.position : ""}
        data-visible={field.field_type !== "hidden" ? "true" : ""}
      >
        {sorted_field_options.map((field_option) => {
          return (
            <FieldOption
              key={"field-option-" + field_option.id}
              field_option={field_option}
              renderVisualComponent={isVisualChoiceComponent()}
              {...props}
            />
          );
        })}
        <BuilderStyleTag
          builder={props.builder}
          styleKey={`cta:${props.cta.id}:element:${element.id}:field:${field.id}:survey`}
          stylesheet={stylesheet}
        />
      </div>
      <FieldSurveyNext {...props} />
    </React.Fragment>
  );
};

const style = {
  classes: (element) => {
    let options = element.options;
    let classes = "cf-survey-field ";

    let alignmentClass = "cf-outer-center";
    if (
      ["custom", "cf-survey-responsive"].includes(options["options-width"]) &&
      options["options-display"] == "table" &&
      options["cf-alignment"]
    ) {
      if (options["cf-alignment"].indexOf("left") > -1) {
        alignmentClass = "cf-outer-left";
      } else if (options["cf-alignment"].indexOf("center") > -1) {
        alignmentClass = "cf-outer-center";
      } else if (options["cf-alignment"].indexOf("right") > -1) {
        alignmentClass = "cf-outer-right";
      }
    }
    classes += alignmentClass;

    return classes;
  },
};

export default FieldSurvey;
